import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import '../AdminEditUser/AdminEditUser.css';

const API_URL = process.env.REACT_APP_API_URL  ;

const CreateUser = () => {
  const navigate = useNavigate();
  const [ form, setForm] = useState({   name: '', lastname: '', email: '', country: '', city: '', phone: '', subscriptionLevel: '', password: ''  })

  const handleChange = (e) => {
    setForm ({ ...form, [e.target.name]: e.target.value});
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    fetch(`${API_URL}/users`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(form)
    })
    .then(res => res.json())
    .then(data => {
      alert("User created, enjoy Admin!");
      navigate('/content');
    });
  }

  return(
    <div className="edit-userform" >
      <h2 style={{fontFamily: "regular-futura", fontWeight: "400"}}>Create New User</h2>
      <form className="editUserForm" onSubmit={handleSubmit}>
          <div><p>Name</p>
            <input name="name" value={form.name} onChange={handleChange} placeholder="First Name"/>
          </div>
          <div><p>Last Name</p>
            <input name="lastname" value={form.lastname} onChange={handleChange} placeholder="Last Name"/>
          </div>
          <div><p>E-mail</p>
            <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="E-mail"/>
          </div>
          <div><p>Country</p>
            <input name="country" value={form.country} onChange={handleChange} placeholder="Country" />
          </div>
          <div><p>City</p>
            <input name="city" value={form.city} onChange={handleChange} placeholder="City" />
          </div>
          <div><p>Phone</p>
            <input name="phone" value={form.phone} onChange={handleChange} placeholder="Phone" />
          </div>
          <div><p>Subscription Level</p>
            <input name="subscriptionLevel" value={form.subscriptionLevel} onChange={handleChange} placeholder="Subscription Level" />
          </div>
          <div><p>Password</p>
            <input name="password" value={form.password} onChange={handleChange} placeholder="Change Password of the User**" />
          </div>
          
          <div style={{alignItems:"right !important"}} className="createButton" >
            <button type="submit" >Create User</button> 
          </div>
      </form>
    </div>
  )
}

export default CreateUser;